import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  searchByPageDrugOrderSync
} from "app/services/DrugService";
import { syncListProductToCrm } from "app/services/SyncCRMService";

export default class ProductAsyncStore {
  searchRegisterProduct = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
  };
  selectProductAsync = [];
  resetSelectedRows = false;

  pageRegisterProduct = new PageResponse();

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterProduct = async () => {
    let { ...ortherData } = this.searchRegisterProduct;
    return await searchByPageDrugOrderSync({ ...ortherData })
      .then(({ data }) => {
        this.pageRegisterProduct = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu sản phẩm có lỗi");
      });
  };

  setSelectProductAsync = (list) => {
    this.selectProductAsync = list;
  };

  syncListProductToCrm = async () => {
    const productIds = this.selectProductAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await syncListProductToCrm(productIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        if (data) {
          toast.success("Đồng bộ sản phẩm thành công");
          this.pagingRegisterProduct();
        } else {
          toast.error("Đồng bộ sản phẩm có lỗi");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        console.error(error);
        toast.error("Đồng bộ sản phẩm có lỗi");
      });
  };
  handleChangeFormSearchProduct = (searchRegisterProduct) => {
    this.searchRegisterProduct = {
      ...this.searchRegisterProduct,
      ...searchRegisterProduct,
    };
    this.pagingRegisterProduct();
  };

  resetStore = () => {
    this.searchRegisterProduct = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      isSyncedToCRM: false,
    };
    this.pageRegisterProduct = new PageResponse();
  };
}
